import { memo } from 'react'

/**
 * Figma Head Component — заголовок каталога
 *
 * Props:
 * - title: заголовок (текст)
 * - leftIcon: иконка слева (React element или путь к SVG)
 * - rightIcons: массив иконок справа (React elements или пути к SVG)
 * - onLeftIconClick: обработчик клика на левую иконку
 * - onRightIconClick: обработчик клика на правую иконку (index: number) => void
 * - className: дополнительные классы
 *
 * Размеры из Figma:
 * - Размер: 361×38px (ширина зависит от контейнера)
 * - Font: SF Pro Display Semibold 590, 28px для заголовка
 * - Icon buttons: 38×38px каждая
 */

function Head({
  title,
  leftIcon,
  rightIcons = [],
  onLeftIconClick,
  onRightIconClick,
  className = '',
}) {
  const renderIcon = (icon) => {
    if (typeof icon === 'string') {
      return (
        <img loading="eager"
          src={icon}
          alt=""
          width="20"
          height="20"
          className="h-5 w-5 object-contain"
          aria-hidden="true"
        />
      )
    }
    return icon
  }

  return (
    <header
      className={`
        flex items-center justify-between
        w-full h-[38px]
        ${className}
      `}
    >
      {/* Left side — icon или title */}
      <div className="flex items-center gap-3">
        {leftIcon && (
          <button
            type="button"
            onClick={onLeftIconClick}
            className="
              flex items-center justify-center
              h-[38px] w-[38px]
              rounded-full
              bg-[var(--figma-surface-08)]
              text-[var(--figma-text)]
              transition-all duration-[160ms]
              active:scale-[0.94]
            "
          >
            {renderIcon(leftIcon)}
          </button>
        )}

        {title && (
          <h1 className="text-[28px] font-[590] leading-[32px] tracking-[-0.01em] text-[var(--figma-text)]">
            {title}
          </h1>
        )}
      </div>

      {/* Right side — icon buttons */}
      {rightIcons.length > 0 && (
        <div className="flex items-center gap-2">
          {rightIcons.map((icon, index) => (
            <button
              key={index}
              type="button"
              onClick={() => onRightIconClick?.(index)}
              className="
                flex items-center justify-center
                h-[38px] w-[38px]
                rounded-full
                bg-[var(--figma-surface-08)]
                text-[var(--figma-text)]
                transition-all duration-[160ms]
                active:scale-[0.94]
              "
            >
              {renderIcon(icon)}
            </button>
          ))}
        </div>
      )}
    </header>
  )
}

export default memo(Head)
